import { extend } from 'flarum/extend';
import app from 'flarum/app';
import IndexPage from 'flarum/components/IndexPage';
import username from 'flarum/common/helpers/username';
import formatNumber from 'flarum/utils/formatNumber';
import listItems from 'flarum/helpers/listItems';
import AvatarEditor from 'flarum/components/AvatarEditor';
import SignUpModal from 'flarum/components/SignUpModal';
import Button from 'flarum/common/components/Button';
import registerWidget from '../common/registerWidget';
import moment from 'moment';

app.initializers.add('justoverclock/flarum-ext-welcomebox', () => {
    registerWidget(app);
    extend(IndexPage.prototype, 'sidebarItems', (items) => {
        const user = app.session.user;
        const lastSeenAt = user?.lastSeenAt() !== null ? user?.lastSeenAt() : false;
        const userLang = app.translator.getLocale();
        const SettingsLink = app.route('settings');
        const useWidget = app.forum.attribute('justoverclock-welcomebox.UseWidget');

        if (!useWidget && user) {
            items.add(
                'WelcomeBox',
                <div className="containerwb">
                    <div className="backgrwb">
                            <div>
                                    <div className="avatarwb">{AvatarEditor.component({ user })}</div>
                            </div>,
                            <div className="contentwb">
                                <div className="textinfo">
                                    {app.translator.trans('flarum-ext-welcomebox.forum.wback')}
                                    <br />
                                    <strong>{username(user)}</strong>
                                </div>
                            </div>,
                            <div className="iconbadge">{listItems(user.badges().toArray())}</div>,
                    </div>
                </div>,
                20
            );
        }
    });
});
extend(IndexPage.prototype, 'sidebarItems', (items) => {
    const isLoginAvailable = app.forum.attribute('allowSignUp');
    const useWidget = app.forum.attribute('justoverclock-welcomebox.UseWidget');
    const ImgAvatar = app.forum.attribute('imgUrl') || app.forum.attribute('baseUrl') + '/assets/extensions/justoverclock-welcomebox/no-avatar.png';

    const SignupComponent = {
        view: function () {
            if (isLoginAvailable) {
                return (
                    <button
                        className=".SplitDropdown-button Button Button--primary hasIcon"
                        type="button"
                        onclick={(componentClass, attrs) => app.modal.show(SignUpModal, attrs)}
                    >
                        {app.translator.trans('core.forum.header.sign_up_link')}
                    </button>
                );
            }
            return null;
        },
    };

    if (!useWidget) {
        if (!app.session.user) {
            if (app.forum.attribute('HideGuestBox') === true) {
                items.add(
                    'welcomeBoxGuest',
                    <div className="containerwb">
                        <div className="backgrwbguest">
                            <img className="guestavatarimg" src={ImgAvatar} />
                            <div className="guesttext">{app.translator.trans('flarum-ext-welcomebox.forum.welcomeguest')}</div>
                            <p className="guestdesc">{app.translator.trans('flarum-ext-welcomebox.forum.notregistered')}</p>
                            {m(SignupComponent)}
                            <div className="contentwb"></div>
                        </div>
                    </div>,
                    20
                );
            }
        }
    }
});
